import MuiTextField from '@mui/material/TextField';

import { Icon } from 'Icon';
import { styled } from 'helpers';

import { TextFieldProps } from './TextField';

// prettier-ignore
export const TextField = styled(MuiTextField, {shouldForwardProp: (prop) => prop !== 'iconProps' && prop !== 'icon'})<TextFieldProps>`
  /* input styles */
  & .MuiInputBase-root.MuiOutlinedInput-root {
    background-color: ${({ theme }) => theme.palette.common.white};
    border: 1px solid ${({ theme }) => theme.palette.blueGrey['A200']};
 
    & .MuiInputBase-input {
      padding: 8px 16px;
      line-height: 1.5;
      height: unset;

      &.MuiOutlinedInput-input.Mui-disabled{
        color: ${({ theme }) => theme.palette.blueGrey['A600']};
        -webkit-text-fill-color: ${({ theme }) => theme.palette.blueGrey['A600']};
      }
      &::placeholder {
        color: ${({ theme }) => theme.palette.blueGrey['A300']};
        opacity: 1;
      }
    }

    .MuiInputAdornment-root {
      background-color: transparent;
    }

    &.Mui-disabled{
      background-color: ${({ theme }) => theme.palette.secondary.main};
      color: ${({ theme }) => theme.palette.blueGrey['A600']};
    }

    &.Mui-focused {
      border-color: ${({ theme }) => theme.palette.blue['800']};
    }
    
    &.Mui-error:not(.Mui-disabled) {
      border-color: ${({ theme }) => theme.palette.error.dark};
    }
  }

  /* fieldset styles */
  & .MuiOutlinedInput-notchedOutline,
  .MuiOutlinedInput-root:not(.Mui-error):not(.Mui-focused) .MuiOutlinedInput-notchedOutline,
  .MuiOutlinedInput-root:hover:not(.Mui-error):not(.Mui-focused) .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  /* Label styles */
  & .MuiFormLabel-root,
  & .MuiFormLabel-root.Mui-focused:not(.Mui-error),
  & .MuiFormLabel-root.Mui-disabled,
  &:hover .MuiFormLabel-root:not(.Mui-error) {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
    display: block;
    position: static;
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.typography.pxToRem(10)};
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    line-height: 14px;
    letter-spacing: 0.3px;
    pointer-events: auto; // for some reason MUI defaults the value to 'none', which breaks the browser's ability to focus the input
    transform: none;
    padding-bottom: 8px;
  }

  /* label styles -- error */
  & .MuiInputLabel-asterisk.MuiFormLabel-asterisk.Mui-error:not(.Mui-disabled),
  & .MuiFormLabel-root.Mui-error:not(.Mui-disabled) {
    color: ${({ theme }) => theme.palette.error.dark};
  }

  /* required asterisk -- disabled */
  & .MuiInputLabel-asterisk.MuiFormLabel-asterisk,
  & .MuiFormLabel-root.Mui-error.Mui-disabled .MuiInputLabel-asterisk.MuiFormLabel-asterisk {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
  }
  /* Helper text styles */
  .MuiFormHelperText-root,
  .MuiFormHelperText-root.Mui-disabled {
    margin-left: 0;
    margin-top: 4px;
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
  }

  .MuiFormHelperText-root.Mui-error:not(.Mui-disabled) {
    color: ${({ theme }) => theme.palette.error.dark};
  }
`;

export const StyledTextFieldIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.blueGrey['A400']};
`;

export default TextField;
